/**
 * オーバーレイポップアップ（CMP閉了後・初回訪問者のみ表示）
 * - webtru CMP (#datasign_cmp__host の Shadow DOM 内) が閉じたことを検知して表示
 * - 閉じた履歴は localStorage に保存し、二度と表示しない
 */
(function () {
  // 表示履歴を保存するキー
  var STORAGE_KEY = 'overlay_popup_after_cmp_closed';
  // CMPホストのID
  var CMP_HOST_ID = 'datasign_cmp__host';
  // CMPコンテナのクラス
  var CMP_CONTAINER_CLASS = 'datasign__triggerAndDialogContainer--index-module';
  // CMPダイアログのID
  var CMP_DIALOG_ID = 'datasign_cmp__cmp_summary';
  // CMPトリガーのID
  var CMP_TRIGGER_ID = 'datasign_cmp__cmp_trigger';
  // CMP が Shadow 内にコンテナを描画するまで待つ時間（即時だとコンテナ未取得のため）
  var CMP_DETECTION_DELAY_MS = 2000;

  // 前回の表示履歴を確認
  function hasClosedBefore() {
    try {
      return !!localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return false;
    }
  }

  // 表示履歴を保存
  function markClosed() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  // オーバーレイポップアップの要素を取得
  function getOverlayEl() {
    return document.querySelector('.overlay-popup-after-cmp');
  }

  // オーバーレイポップアップを表示
  function showPopup() {
    var overlay = getOverlayEl();
    if (!overlay) return;
    overlay.classList.remove('overlay-popup-after-cmp--hidden');
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  // オーバーレイポップアップを非表示
  function hidePopup() {
    var overlay = getOverlayEl();
    if (!overlay) return;
    overlay.classList.add('overlay-popup-after-cmp--hidden');
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    markClosed();
  }

  // オーバーレイポップアップの閉じるボタンをバインド
  function bindCloseHandlers() {
    var overlay = getOverlayEl();
    if (!overlay) return;
    overlay.querySelectorAll('[data-overlay-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        hidePopup();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
        hidePopup();
      }
    });
  }

  // CMPダイアログが閉じたかどうかを確認
  function isCmpDialogClosed(container) {
    return (
      container.querySelector('#' + CMP_TRIGGER_ID) &&
      !container.querySelector('#' + CMP_DIALOG_ID)
    );
  }

  // shadowRoot 全体を監視し、発火のたびにコンテナを再取得して閉了判定（CMP がコンテナを差し替える場合に対応）
  function observeShadowRootForCmpClose(shadowRoot, onClosed) {
    var observer = new MutationObserver(function (mutations) {
      var container = findContainerInShadowRoot(shadowRoot);
      if (!container) return;
      if (isCmpDialogClosed(container)) {
        observer.disconnect();
        onClosed();
      }
    });
    observer.observe(shadowRoot, { childList: true, subtree: true });
  }

  // CMPホストの読み込みを待つ
  function waitForCmpHost(callback) {
    var host = document.getElementById(CMP_HOST_ID);
    if (host && host.shadowRoot) {
      callback(host.shadowRoot);
      return;
    }
    var attempts = 0;
    var maxAttempts = 100;
    var interval = setInterval(function () {
      attempts++;
      host = document.getElementById(CMP_HOST_ID);
      if (host && host.shadowRoot) {
        clearInterval(interval);
        callback(host.shadowRoot);
        return;
      }
      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 300);
  }

  // Shadow DOM 内のコンテナを検索
  function findContainerInShadowRoot(shadowRoot) {
    var selector = '.' + CMP_CONTAINER_CLASS.split(/\s+/).join('.');
    return shadowRoot.querySelector(selector);
  }

  // Shadow DOM 内のコンテナを待つ
  function waitForContainer(shadowRoot, callback) {
    var container = findContainerInShadowRoot(shadowRoot);
    if (container) {
      callback(container);
      return;
    }
    var attempts = 0;
    var maxAttempts = 50;
    var interval = setInterval(function () {
      attempts++;
      container = findContainerInShadowRoot(shadowRoot);
      if (container) {
        clearInterval(interval);
        callback(container);
        return;
      }
      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 200);
  }

  // URL の ?test_country=XX を取得（挙動確認用。指定時はその国として判定）
  function getTestCountryFromUrl() {
    var match = typeof window !== 'undefined' && window.location && window.location.search
      ? window.location.search.match(/[?&]test_country=([A-Za-z]{2})/)
      : null;
    return match ? match[1].toUpperCase() : null;
  }

  // Shopify が検出した閲覧者の国コードを取得（コールバックで handle または null を返す）
  function getDetectedCountry(callback) {
    var url = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'browsing_context_suggestions.json'
      : '/browsing_context_suggestions.json';
    url += '?country[enabled]=true';
    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var country = (data.detected_values && data.detected_values.country)
          ? data.detected_values.country.handle
          : null;
        callback(country ? country.toUpperCase() : null);
      })
      .catch(function () { callback(null); });
  }

  // 販売対象国に含まれる場合は true（オーバーレイを表示しない）
  function isInSellingCountries(detectedCountryCode, sellingCountryCodes) {
    if (!detectedCountryCode || !sellingCountryCodes || sellingCountryCodes.length === 0) return false;
    return sellingCountryCodes.indexOf(detectedCountryCode) !== -1;
  }

  // Shopify が検出した閲覧者の言語・国をコンソールに表示（販売対象国判定の確認用）
  function logDetectedContext() {
    var testCode = getTestCountryFromUrl();
    if (testCode) {
      console.log('[Overlay] テスト用: ?test_country=' + testCode + ' を適用して表示可否を判定しています');
    }
    var url = (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'browsing_context_suggestions.json'
      : '/browsing_context_suggestions.json';
    url += '?country[enabled]=true&language[enabled]=true';
    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var detected = data.detected_values || {};
        var suggestions = data.suggestions || [];
        var lang = detected.language || (suggestions[0] && suggestions[0].parts && suggestions[0].parts.language);
        var country = detected.country;
        console.log('[Overlay] 閲覧者の言語（Shopify検出）:', lang ? lang.name + ' (' + lang.handle + ')' : '取得できませんでした');
        console.log('[Overlay] 閲覧者の国（Shopify検出）:', country ? country.name + ' (' + country.handle + ')' : '取得できませんでした');
      })
      .catch(function (err) {
        console.warn('[Overlay] browsing_context_suggestions の取得に失敗しました', err);
      });
  }

  // CMP 検知〜オーバーレイ表示までの処理（販売対象国チェック後に実行）
  function proceedWithCmpDetection() {
    logDetectedContext();
    bindCloseHandlers();
    setTimeout(function () {
      waitForCmpHost(function (shadowRoot) {
        waitForContainer(shadowRoot, function (container) {
          if (isCmpDialogClosed(container)) {
            showPopup();
            return;
          }
          observeShadowRootForCmpClose(shadowRoot, showPopup);
        });
      });
    }, CMP_DETECTION_DELAY_MS);
  }

  // 初期化
  function init() {
    if (hasClosedBefore()) return;
    var overlay = getOverlayEl();
    if (!overlay) return;

    bindCloseHandlers();

    var showOnlyOutside = overlay.getAttribute('data-show-only-outside-selling-countries') === 'true';
    var sellingCodesStr = overlay.getAttribute('data-selling-country-codes');
    var sellingCountryCodes = (sellingCodesStr && sellingCodesStr.trim())
      ? sellingCodesStr.split(',').map(function (s) { return s.trim().toUpperCase(); })
      : [];

    if (!showOnlyOutside || sellingCountryCodes.length === 0) {
      if (!showOnlyOutside) {
        console.log('[Overlay] 「販売対象国以外でのみ表示」がオフのため、国チェックをスキップしています');
      } else {
        console.log('[Overlay] 販売対象国リストが空のため、国チェックをスキップしています');
      }
      proceedWithCmpDetection();
      return;
    }

    getDetectedCountry(function (detectedCode) {
      var countryCode = getTestCountryFromUrl() || detectedCode;
      var inSelling = isInSellingCountries(countryCode, sellingCountryCodes);
      console.log('[Overlay] 国判定: 使用した国コード=', countryCode, '| 販売対象国リスト=', sellingCountryCodes, '| 販売対象国に含まれる=', inSelling);
      if (inSelling) {
        return;
      }
      proceedWithCmpDetection();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



